import React, { FC } from "react";
import { Form, DatePicker } from "antd";
import Util from "../../../util/util";
import { IPaymentPageCustomAttribute } from "@app-models";
import { FormFieldBox } from "./FormFieldBox";

interface CustomDateFieldProps {
  name: string;
  attribute: IPaymentPageCustomAttribute;
  index: number;
}

const CustomDateField: FC<CustomDateFieldProps> = ({ name, attribute, index }) => {
  const v = Util.parseValidationValue(attribute) as { startDate?: string; endDate?: string };
  const rules = [
    { required: attribute.mandatory, message: "Field is mandatory" },
    ...(v.startDate || v.endDate ? [Util.dateRangeRule(v.startDate, v.endDate)] : []),
  ];
  const disabledDate = (current: any) => !!Util.validateDateRange(current, v.startDate, v.endDate);

  return (
    <div className="name-field field-title-case" style={{ marginBottom: 24 }}>
      <Form.Item name={name} rules={rules}>
        <FormFieldBox label={attribute.fieldName}>
          {(props) => (
            <DatePicker
              {...props}
              placeholder={attribute.fieldName}
              style={{ width: "100%" }}
              disabledDate={disabledDate}
            />
          )}
        </FormFieldBox>
      </Form.Item>
    </div>
  );
};

export default CustomDateField;
